import { useWSMutation } from "@ws-react-query";
import { REQUIREMENTS_DEPENDENCIES } from "../../../modules/Requirements/dependencies";
import { submitInsuranceImport } from "../../../services/api/insurance/import/submitInsuranceImport";
import { QUERY_INSURANCE_IMPORT } from "../keys";

export const useSubmitInsuranceImport = () => {
  return useWSMutation(
    ({ insuranceImportId }: { insuranceImportId: string }) => {
      return submitInsuranceImport(insuranceImportId);
    },
    {
      dependencies: [QUERY_INSURANCE_IMPORT, ...REQUIREMENTS_DEPENDENCIES]
    }
  );
};
